<template>
  <div
    class="relative w-full h-full"
    :id="getCanvasBoxId(cameraInfo.IpPort)"
  ></div>
</template>

<script>
import Axios from 'axios'
import { IOTDeviceProtocolInstanceApi } from '@wiz-api/iot-device-management'

const iOTDeviceProtocolInstanceApi = new IOTDeviceProtocolInstanceApi()

export default {
  props: {
    cameraInfo: {
      type: Object,
      default: () => {
        return {
          IpPort: '',
          StreamUrl: '',
        }
      },
      require: true,
    },
    pIid: {
      type: String,
      default: '',
    },
    isDialog: {
      type: Boolean,
      default: false,
      require: true,
    },
  },
  watch: {
    cameraInfo: {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          this.changeCode(newVal, oldVal)
        })
      },
      deep: true,
    },
  },
  data() {
    return {
      JSMpeg: null,
      hostInfo: {}
    }
  },
  methods: {
    async startCamera(IpPort) {
      // 获取或创建 canvas 元素
      const canvas = document.createElement('canvas')
      canvas.id = this.getCanvasId(IpPort)
      canvas.style.height = '100%'
      canvas.style.width = '100%'
      document.getElementById(this.getCanvasBoxId(IpPort)).appendChild(canvas)

      // const nowrtsp = `rtsp://admin:tc123456@${IpPort}/cam/realmonitor?channel=1&subtype=0`
      // 内网测试用
      // const nowIp = '172.16.203.109'
      // const nowrtsp = 'rtsp://admin:pr@wiz.top@172.16.203.109/Streaming/Channels/1'

      try {
        // 请求 FFmpeg 流
        const response = await fetch(`http://${this.hostInfo.ApiHost}:${this.hostInfo.Port}/postFFmpegStream`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            streamUrl: this.cameraInfo.StreamUrl,
            wsPort: -1,
            ip: IpPort,
          }),
        })
        const responseData = await response.json()
        console.log('请求 FFmpeg 流:', responseData)
        const playerUrl = `ws://${this.hostInfo.ApiHost}:${responseData?.wsPort}`

        // 创建 JSMpeg 播放器
        this.$nextTick(() => {
          /* global JSMpeg */
          this.JSMpeg = new JSMpeg.Player(playerUrl, { canvas })
        })
      } catch (error) {
        console.error('请求 FFmpeg 流失败:', error)
      }
    },
    closeCamera(IpPort) {
      this.JSMpeg = null
      const canvas = document.getElementById(this.getCanvasId(IpPort))
      if (canvas) {
        // 销毁id等于playersinglecanvas的canvas
        canvas.remove()
      }
    },
    changeCode(newVal, oldVal) {
      this.closeCamera(oldVal.IpPort)
      this.startCamera(newVal.IpPort)
    },
    async getApiHost() {
      const [err, res] = await iOTDeviceProtocolInstanceApi.get(this.pIid)
      if (!err && res) {
        this.hostInfo = JSON.parse(res.jsonContent) || {}
      }
    }
  },
  computed: {
    getCanvasId() {
      return (IpPort) => {
        if (this.isDialog) {
          return `playersinglecanvas${IpPort}dialog`
        }
        return `playersinglecanvas${IpPort}`
      }
    },
    getCanvasBoxId() {
      return (IpPort) => {
        if (this.isDialog) {
          return `canvasbox${IpPort}dialog`
        }
        return `canvasbox${IpPort}`
      }
    },
  },
  async  mounted() {
    console.log('mounted:cameraInfo', this.cameraInfo)
    await this.getApiHost()
    this.startCamera(this.cameraInfo.IpPort)
  },
  beforeDestroy() {
    this.closeCamera(this.cameraInfo.IpPort)
  },
}
</script>
